import { Box } from "@chakra-ui/react";
import type { EspdResponseDto, ResolvedEspdCriterionDto } from "../../../../../autogen/bff-api";
import { StepNavigation } from "../../../../../common/StepNavigation";
import { EspdExclusionCriteriaList } from "../../bid/espd/EspdExclusionCriteriaList";

interface Props {
  criteria: ResolvedEspdCriterionDto[];
  espd: EspdResponseDto;
  onChange: (next: EspdResponseDto) => void;
  readOnly: boolean;
  isSaving: boolean;
  previousStep?: () => void;
  nextStep?: () => void;
  nextStepLabel?: string;
}

export const ContributionExclusionStep = ({
  criteria,
  espd,
  onChange,
  readOnly,
  isSaving,
  previousStep,
  nextStep,
  nextStepLabel,
}: Props) => (
  <Box pb="8" pt="6">
    <Box mb="8">
      <EspdExclusionCriteriaList
        criteria={criteria}
        espd={espd}
        onChange={onChange}
        readOnly={readOnly}
        isSaving={isSaving}
      />
    </Box>
    <StepNavigation onPrevious={previousStep} onNext={nextStep} nextLabel={nextStepLabel} />
  </Box>
);
